// extracted by mini-css-extract-plugin
export var subtitle = "_9c-2";
export var title = "_9c-0";
export var titleNoWrap = "_9c-1";